module.exports = __webpack_public_path__ + "static/iframes-1-bbbf7847074d01fef4fa9ebbe397af18.png";